<template>
<div class="colapsables">
     <div class="edicion_block">
        <div  @click="show.s1=!show.s1" class="navcola manito"  style="border-top:0px !important;">
        <h4>{{$t('style.info.menu')}}</h4>
            <Icon :icon="show.s1 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
        </div>
        <div :class="'contenido '+show.s1" v-show-slide="show.s1">
          
            <div class="row form_row">
                <div class="col-lg-6">
                    <colorPicker  :label="$t('pickers.colorfondo')"  :color="general.menu_sup.background" :value="general.menu_sup.background" @input="updateGeneralKey({ key: 'menu_sup', subkey: 'background', value: $event.hex ? $event.hex : $event })"/>
                </div>
                <div class="col-lg-6">
                    <colorPicker :color="general.menu_sup.color" :value="general.menu_sup.color" @input="updateGeneralKey({ key: 'menu_sup', subkey: 'color', value: $event.hex ? $event.hex : $event })" />
                </div>
            </div>
        </div>
    </div>
    <div  class="edicion_block" >
            <div  @click="show.s2=!show.s2" class="navcola manito" >
                <h4>{{$t('style.generales.fondo')}}</h4>
            <Icon :icon="show.s2 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
            </div>
            <div :class="'contenido '+show.s2" v-show-slide="show.s2">
                <div class="row form_row">
                    <div class="col-lg-8">
                        <imagePicker imgid="background" :btext="$t('pickers.loadi')" :value="membre.fondo.img" @input="updateMembreKey({ key: 'fondo', subkey: 'img', value: $event })" />
                    </div>
                    <div class="col-lg-4">
                        <switchPicker :value="membre.fondo.active" @input="updateMembreKey({ key: 'fondo', subkey: 'active', value: $event })"/>
                    </div>
                    <div class="col-lg-6">
                        <switchPicker :value="membre.fondo.animacion" @input="updateMembreKey({ key: 'fondo', subkey: 'animacion', value: $event })" :label="$t('pickers.movement')"/>
                    </div>
                    <div class="col-lg-6">
                        <opacityPicker :value="membre.fondo.opacity" @input="updateMembreKey({ key: 'fondo', subkey: 'opacity', value: $event })"/>
                    </div>
                    <div class="col-lg-6">
                        <colorPicker :label="$t('pickers.colorfondo')"  :color="membre.fondo.background" :value="membre.fondo.background" @input="updateMembreKey({ key: 'fondo', subkey: 'background', value: $event.hex ? $event.hex : $event })" />
                    </div>
                    <div class="col-lg-6">
                        <sizePicker :value="membre.fondo.width" @input="updateMembreKey({ key: 'fondo', subkey: 'width', value: $event })" :min='50' :max='1200' :interval="50"/>
                    </div>
                    <div class="col-lg-6">
                        <sizePicker :label="$t('pickers.hori')" :value="membre.fondo.left" @input="updateMembreKey({ key: 'fondo', subkey: 'left', value: $event })" :min='-200' :max='200' :interval="10" unit="%"/>
                    </div>
                    <div class="col-lg-6">
                        <sizePicker :label="$t('pickers.verti')" :value="membre.fondo.top" @input="updateMembreKey({ key: 'fondo', subkey: 'top', value: $event })" :min='-100' :max='200' :interval="10" />
                    </div>
                </div>
            </div>
    </div> 
    <div  class="edicion_block" >
            <div  @click="show.s3=!show.s3" class="navcola manito" >
        <h4>{{$t('style.info.nombre')}}</h4>
            <Icon :icon="show.s3 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
            </div>
            <div :class="'contenido '+show.s3" v-show-slide="show.s3">
                <div class="row form_row">
                    <div class="col-12">
                        <fontPicker  :value="membre.nombre.family" @input="updateMembreKey({ key: 'nombre', subkey: 'family', value: $event })"/>
                    </div>
                </div>
                <div class="row form_row">
                    
                    <div class="col-lg-6">
                        <colorPicker :color="membre.nombre.color"  :value="membre.nombre.color" @input="updateMembreKey({ key: 'nombre', subkey: 'color', value: $event.hex ? $event.hex : $event })" />
                    </div>
                    <div class="col-lg-6">
                        <sizePicker :min="400" :max="900" :interval="100" :label="$t('pickers.weight')" :unit="''"  :value="membre.nombre.weight" @input="updateMembreKey({ key: 'nombre', subkey: 'weight', value: $event })"/>
                    </div>
                    <div class="col-lg-6">
                        <sizePicker :value="membre.nombre.size" @input="updateMembreKey({ key: 'nombre', subkey: 'size', value: $event })"/>
                    </div>
                </div>
            </div>
    </div>
    <div  class="edicion_block" >
            <div  @click="show.s4=!show.s4" class="navcola manito" >
                <h4>{{$t('style.info.mnumber')}}</h4>
            <Icon :icon="show.s4 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
            </div>
            <div :class="'contenido '+show.s4" v-show-slide="show.s4">
                <div class="row form_row">
                    <div class="col-12">
                        <fontPicker  :value="membre.cargo.family" @input="updateMembreKey({ key: 'cargo', subkey: 'family', value: $event })"/>
                    </div>
                </div>
                <div class="row form_row">
                    <div class="col-lg-6">
                        <sizePicker :min="400" :max="900" :interval="100" :label="$t('pickers.weight')" :unit="''"  :value="membre.cargo.weight" @input="updateMembreKey({ key: 'cargo', subkey: 'weight', value: $event })"/>
                    </div>
                    <div class="col-lg-6">
                        <sizePicker :value="membre.cargo.size" @input="updateMembreKey({ key: 'cargo', subkey: 'size', value: $event })"/>
                    </div>
                </div>

                <div class="row form_row">
                    <div class="col-lg-12">
                        <colorPicker :color="membre.cargo.color" :value="membre.cargo.color" @input="updateMembreKey({ key: 'cargo', subkey: 'color', value: $event.hex ? $event.hex : $event })" />
                    </div>
                </div>
            </div>
    </div>
    <div  class="edicion_block" >
            <div  @click="show.s5=!show.s5" class="navcola manito" >
                <h4>{{$t('style.membre.punta')}}</h4>
            <Icon :icon="show.s5 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
            </div>
            <div :class="'contenido '+show.s5" v-show-slide="show.s5">
                <div class="row form_row">
                    <div class="col-lg-6">
                        <colorPicker  :label="$t('pickers.colorfondo')"  :color="membre.creditos.background" :value="membre.creditos.background" @input="updateMembreKey({ key: 'creditos', subkey: 'background', value: $event.hex ? $event.hex : $event })"/>
                    </div>
                    <div class="col-lg-6">
                        <colorPicker :color="membre.creditos.color" :value="membre.creditos.color" @input="updateMembreKey({ key: 'creditos', subkey: 'color', value: $event.hex ? $event.hex : $event })" />
                    </div>
                </div>
            </div>
    </div>
    
    <div  class="edicion_block" >
            <div  @click="show.s6=!show.s6" class="navcola manito" >
                <h4>{{$t('style.membre.info')}}</h4>
            <Icon :icon="show.s6 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
            </div>
            <div :class="'contenido '+show.s6" v-show-slide="show.s6">
                <div class="row form_row">
                    <div class="col-lg-6">
                        <colorPicker  :label="$t('pickers.colorfondo')"  :color="membre.datos.background" :value="membre.datos.background" @input="updateMembreKey({ key: 'datos', subkey: 'background', value: $event.hex ? $event.hex : $event })"/>
                    </div>
                    <div class="col-lg-6">
                        <colorPicker :color="membre.datos.color" :value="membre.datos.color" @input="updateMembreKey({ key: 'datos', subkey: 'color', value: $event.hex ? $event.hex : $event })" />
                    </div>
                </div>
            </div>
    </div>

    
    <!-- BLOCK EDITAR "CAJA DE LOGO" -->
    <div  class="edicion_block" >
            <div  @click="show.s7=!show.s7" class="navcola manito" >
                <h4>{{$t('style.info.caja')}}</h4>
            <Icon :icon="show.s7 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
            </div>
            <div :class="'contenido '+show.s7" v-show-slide="show.s7">
                
                <div class="row form_row">
                    <div class="col-lg-8">
                        <imagePicker imgid="bottom_logo" :value="membre.caja_logo.img" @input="updateMembreKey({ key: 'caja_logo', subkey: 'img', value: $event })" />        
                    </div>
                    <div class="col-lg-4">
                        <label class="switch">
                            <input type="checkbox" :checked="membre.caja_logo.active" @change="updateMembreKey({ key: 'caja_logo', subkey: 'active', value: $event.target.checked })">
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <div class="col-lg-12">
                        <colorPicker :label="$t('pickers.colorfondo')"  :color="membre.caja_logo.background" :value="membre.caja_logo.background" @input="updateMembreKey({ key: 'caja_logo', subkey: 'background', value: $event.hex ? $event.hex : $event })" />
                    </div>
                    <div class="col-lg-12">
                        <label>{{$t('general.url')}}</label>
                        <input type="text" maxlength="150" v-validate="'url:require_protocol'" name="url" class="form-control input_wicon input_website"  :placeholder="$t('style.info.urlp')" :value="membre.caja_logo.url" @input="updateMembreKey({ key: 'caja_logo', subkey: 'url', value: $event.target.value })">
                        <client-only><span class="vuerror">{{ errors.first('url') }}</span></client-only>
                    </div>
                </div>
            </div>
    </div>

</div>
</template>
<script>

import colorPicker from './dinputs/colorPicker'
import sizePicker from './dinputs/sizePicker'
import animacionPicker from './dinputs/animacionPicker'
import efectPicker from './dinputs/efectPicker'
import opacityPicker from './dinputs/opacityPicker'
import imagePicker from '@/components/imagePicker.vue'
import fontPicker from './dinputs/fontPicker'
import switchPicker from './dinputs/switchPicker'

export default {
    data(){
        return{
            show:{
                s1:false,s2:false,s3:false,s4:false,s5:false,s6:false,s7:false,s8:false,
            },
            colors:'',
        }
    },
  
    computed: {
        
        membre () { return this.$store.getters.editingLinckard.style.membre},
        general () { return this.$store.getters.editingLinckard.style.general}

    },
    methods:{
      updateMembreKey({ key, value, subkey = null }) {
        const newLinckard = JSON.parse(JSON.stringify(this.$store.getters.editingLinckard));
        if (subkey) {
          newLinckard.style.membre[key][subkey] = value;
        } else {
          newLinckard.style.membre[key] = value;
        }
        this.$store.commit('changeActiveEdit', newLinckard);
      },
      updateGeneralKey({ key, value, subkey = null }) {
        const newLinckard = JSON.parse(JSON.stringify(this.$store.getters.editingLinckard));
        if (subkey) {
          newLinckard.style.general[key][subkey] = value;
        } else {
          newLinckard.style.general[key] = value;
        }
        this.$store.commit('changeActiveEdit', newLinckard);
      }
    },
    components: {
        'colorPicker':colorPicker,
        'fontPicker':fontPicker,
        'switchPicker':switchPicker,
        'imagePicker':imagePicker,
        'sizePicker':sizePicker,
        'animacionPicker':animacionPicker,
        'efectPicker':efectPicker,
        'opacityPicker':opacityPicker,
    }
}


</script>


<style>


</style>
